import { render, staticRenderFns } from "./TraitePhotoApp.vue?vue&type=template&id=acade926&scoped=true&"
import script from "./TraitePhotoApp.vue?vue&type=script&lang=js&"
export * from "./TraitePhotoApp.vue?vue&type=script&lang=js&"
import style0 from "./TraitePhotoApp.vue?vue&type=style&index=0&id=acade926&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acade926",
  null
  
)

export default component.exports